import { useState } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import { itemByLanguage } from '@/utils/language';

import PreviewResourceModal from './components/PreviewResourceModal';
import { isPlanResourceReference } from './utils';

import { PlanStep } from '@/_generated/api-clients/xp';

interface ResourceNameProps {
  step: PlanStep;
  name: string;
}

const ResourceName: React.FC<ResourceNameProps> = ({ step, name }) => {
  const [isResourcePreviewOpen, setIsResourcePreviewOpen] = useState(false);

  const referencesMap = step.resource?.references
    ? Object.fromEntries(
        step.resource.references.map(ref => [ref.language, ref] as const),
      )
    : undefined;

  const resourceReference = itemByLanguage(referencesMap);

  const handleOpenResourcePreview = () => {
    setIsResourcePreviewOpen(true);
    if (!resourceReference || !isPlanResourceReference(resourceReference)) {
      datadogRum.addError(
        new Error('Resource reference is not a plan resource reference', {
          cause: resourceReference,
        }),
      );
    }
  };

  return (
    <>
      <button
        className="text-variant-body1! w-fit cursor-pointer hover:underline"
        onClick={handleOpenResourcePreview}
      >
        {name.replace(/_/g, ' ')}
      </button>
      {resourceReference && (
        <PreviewResourceModal
          resourceReference={resourceReference}
          open={isResourcePreviewOpen}
          onOpenChange={setIsResourcePreviewOpen}
        />
      )}
    </>
  );
};

export default ResourceName;
